// App.js
// Importações principais do React e Router
import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Analytics } from "@vercel/analytics/react";

// Estilos globais
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/ActionSite.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import 'swiper/css/effect-fade';

// Componentes principais da estrutura (carregados imediatamente)
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// --- Otimização: Carregamento "Preguiçoso" das Páginas ---
// As páginas só serão baixadas quando o usuário navegar até elas.
const Home = lazy(() => import("./components/Inicial/Home"));
const Equipe = lazy(() => import("./components/Equipe/Equipe"));
const ActionCast = lazy(() => import("./components/ActionCast/ActionCast"));
const Faas = lazy(() => import("./components/Faas/Faas"));
const Servicos = lazy(() => import("./components/Servicos/Servicos"));
const BlogList = lazy(() => import("./components/Blog/BlogList"));
const BlogPost = lazy(() => import("./components/Blog/BlogPost"));

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Helmet 
        titleTemplate="%s | Act!on"
        defaultTitle="Act!on | Consultoria Financeira e Estratégica"
      >
        <meta name="description" content="A Action é o parceiro de negócios financeiro para a sua empresa, da estratégia à execução." />
      </Helmet>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        
        {/* ALTERAÇÃO AQUI: Usando o Preloader como fallback para uma transição de página suave */}
        <Suspense fallback={<Preloader load={true} />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/faas" element={<Faas />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/actioncast" element={<ActionCast />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {/* Redireciona qualquer rota não encontrada para a Home */}
            <Route path="*" element={<Navigate to="/"/>} />
          </Routes>
        </Suspense>
        
        <Footer />
      </div>
      <Analytics />
    </Router>
  );
}

export default App;